export interface DemoTourStep {
  element?: string;
  intro: string;
  title?: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  disableInteraction?: boolean;
}

export const DEMO_TOUR_STEPS: DemoTourStep[] = [
  {
    intro:
      'Welcome to the ToothReferral demo. This is a fictional practice — explore freely, but changes are disabled.',
  },
  {
    element: '[data-demo-tour="nav-analytics"]',
    intro: 'Analytics shows referral volume, trends, and performance across your practice.',
    position: 'right',
    disableInteraction: true,
  },
  {
    element: '[data-demo-tour="analytics-tabs"]',
    intro: 'Switch between received and sent referrals to see both sides of your network.',
    position: 'bottom',
    disableInteraction: true,
  },
  {
    element: '[data-demo-tour="analytics-filters"]',
    intro: 'Filter by office, doctor, specialty, and more — just like a real dashboard.',
    position: 'bottom',
    disableInteraction: true,
  },
  {
    element: '[data-demo-tour="nav-referrals-incoming"]',
    intro: 'Incoming referrals lists new patient cases sent to your offices.',
    position: 'right',
    disableInteraction: true,
  },
  {
    element: '[data-demo-tour="nav-offices"]',
    intro: 'The Offices section covers locations, embed forms, and team access.',
    position: 'right',
    disableInteraction: true,
  },
];
